module.exports = __webpack_public_path__ + "img/76_29.2641be86.png";